import { setFlagsAction } from 'flag'
import {
  FETCH_FEATURE_CONFIG,
  INVOKE_REDIRECT
} from '../actions/actionTypes'
import errorHelper from '../../lib/errorHelper'

const communicator = store => next => action => {
  switch (action.type) {
    case FETCH_FEATURE_CONFIG: {
      next(setFlagsAction(action.payload || { features: {} }))
      break
    }

    case INVOKE_REDIRECT: {
      const { url, timeout = 0 } = action.payload || {}
      if (url) {
        console.log(`middleware INVOKE_REDIRECT: Redirecting to ${url}`)
        errorHelper.redirect({ url, timeout })
      } else {
        console.debug(`middleware INVOKE_REDIRECT, link not found, url: ${url}`)
      }
      break
    }
  }

  return next(action)
}

export default communicator
